import { useNavigate } from 'react-router';
import { Button, Card, EmptyState } from '@mgdlead/ui';
import { Compass } from 'lucide-react';

import { useWorkspace } from '../../features/workspace/WorkspaceContext';
import { useDocumentTitle } from '../../lib/useDocumentTitle';

/** 404 DENTRO do shell: o menu continua ali, então a pessoa não fica sem saída. */
export function WorkspaceNotFound() {
  useDocumentTitle('Tela não encontrada');
  const { workspace } = useWorkspace();
  const navigate = useNavigate();

  return (
    <Card padded={false}>
      <EmptyState
        kind="no-data"
        icon={Compass}
        title="Tela não encontrada"
        description="Este endereço não corresponde a nenhuma tela deste workspace."
        action={
          <Button
            variant="primary"
            block
            onClick={() => void navigate(`/w/${workspace.slug}`, { replace: true })}
          >
            Ir para o dashboard
          </Button>
        }
      />
    </Card>
  );
}
